import {
	createSlice,
	PayloadAction,
} from '@reduxjs/toolkit';
import type {
	CompaniesState,
	CompanyPageResult,
} from '@localTypes/company';

const initialState: CompaniesState = {
	isError: false,
	isLoading: true,
	result: [],
	total: 0,
};

export const companiesSlice = createSlice({
	initialState,
	name: 'companies',
	reducers: {
		clearCompanies: (state) => {
			state.isError = false;
			state.isLoading = true;
			state.result = [];
			state.total = 0;
		},
		setCompanyDetails: (state, action: PayloadAction<CompanyPageResult>) => {
			const updated = action.payload;
			if (!updated?.id) return;
			const index = state.result.findIndex(company => company?.id === updated.id);
			if (index >= 0) {
				state.result[index] = updated;
			} else {
				state.result.push(updated);
			}
		},
		setCompanyError: (state, action: PayloadAction<boolean>) => {
			state.isError = action.payload;
		},
		setCompanyLoading: (state, action: PayloadAction<boolean>) => {
			state.isLoading = action.payload;
		},
	},
});

export const {
	clearCompanies,
	setCompanyDetails,
	setCompanyError,
	setCompanyLoading,
} = companiesSlice.actions;

export const companiesReducer = companiesSlice.reducer;
